module.exports = __webpack_public_path__ + "static/img/two.afdf008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expert/two.png
// module id = FX0Q
// module chunks = 0